export default "__VITE_ASSET__2JQ90qDL__"